export default __webpack_public_path__ + "fonts/launchpad-logo-blue.svg";